// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"198":"c3d43bc2","525":"2cf68451","594":"0c3c78a9"}[chunkId] + ".js";
};